import { render } from "./InsertBlock.vue?vue&type=template&id=73903d7b&scoped=true"
import script from "./InsertBlock.vue?vue&type=script&lang=js"
export * from "./InsertBlock.vue?vue&type=script&lang=js"

import "./InsertBlock.vue?vue&type=style&index=0&id=73903d7b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-73903d7b"

export default script